import {Component, inject} from '@angular/core';
import {PrimeNgImportsModule} from '../../../../sdk/src/prime-ng-imports';
import {IBasePageComponent} from '../../../../sdk/src/components/ibase-page/ibase-page.component';
import {ActivatedRoute} from '@angular/router';
import {firstValueFrom} from 'rxjs';
import {ObjectStoreEntryCRUDComponent} from '../../components/object-store-entry-crud/object-store-entry-crud.component';

@Component({
    selector: 'app-cos-object-store-entry-page',
    templateUrl: './cos-object-store-entry-page.component.html',
    imports: [PrimeNgImportsModule, ObjectStoreEntryCRUDComponent]
})
export class COSObjectStoreEntryPage extends IBasePageComponent {
    private readonly activatedRoute = inject(ActivatedRoute);

    protected linkObjectType!: string;
    protected linkObjectUUID!: string;

    // ===============================================================
    // ===============================================================

    /**
     * On ready (Error handling and refresh is done in the parent)
     */
    protected override async onReady(): Promise<void> {
        await this.globalsService.sessionService.getRouteContextIsReadyPromise();

        const routeData = await firstValueFrom(this.activatedRoute.data);
        this.linkObjectType = routeData['linkObjectType'];
        this.linkObjectUUID = routeData['linkObjectUUID'];

        if (this.linkObjectUUID.startsWith(':')) {
            this.linkObjectUUID = this.globalsService.sessionService.lastRouteParams[this.linkObjectUUID.substring(1)];
        }
    }
    /**
     * On destroy (Error handling and refresh is done in the parent)
     */
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    protected override async onDestroy(): Promise<void> {}
}
